import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const OpenAIIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.056 0a4.048 4.048 0 0 0-3.847 2.79A4 4 0 0 0 .543 4.725a4.03 4.03 0 0 0 .499 4.724 3.97 3.97 0 0 0 .341 3.268 4.04 4.04 0 0 0 4.346 1.94A3.989 3.989 0 0 0 8.73 16a4.048 4.048 0 0 0 3.847-2.79 3.978 3.978 0 0 0 2.66-1.935 4.022 4.022 0 0 0-.492-4.724v-.006a3.987 3.987 0 0 0-.342-3.272 4.041 4.041 0 0 0-4.34-1.935A4.005 4.005 0 0 0 7.056 0Zm0 1.04-.005.006c.704 0 1.381.244 1.923.693-.022.011-.065.038-.097.055L5.69 3.63a.519.519 0 0 0-.26.456v4.312l-1.371-.79V4.041A3 3 0 0 1 7.056 1.04Zm3.838 1.256a2.999 2.999 0 0 1 2.962 3.507c-.022-.016-.065-.038-.092-.054l-3.186-1.842a.533.533 0 0 0-.526 0L6.32 6.063V4.481l3.083-1.783a2.984 2.984 0 0 1 1.492-.402Zm-7.88 1.638V7.72c0 .19.098.358.26.455l3.728 2.151-1.377.797-3.077-1.778a3 3 0 0 1 .466-5.412Zm7.141.937 3.083 1.777a2.995 2.995 0 0 1 1.095 4.097l.005.005a2.99 2.99 0 0 1-1.56 1.311V8.274a.518.518 0 0 0-.26-.455L8.783 5.662l1.371-.791ZM7.89 6.177l1.572.91v1.815l-1.572.91-1.57-.91V7.087l1.57-.91Zm2.471 1.43 1.37.791v3.56a3 3 0 0 1-2.995 3.002v-.005a2.99 2.99 0 0 1-1.919-.694c.022-.01.07-.038.098-.054l3.186-1.837a.507.507 0 0 0 .26-.455V7.607Zm-.894 2.33v1.582l-3.083 1.777a3.005 3.005 0 0 1-4.096-1.094h.005a2.975 2.975 0 0 1-.358-2.005c.022.016.065.038.093.054l3.185 1.843a.534.534 0 0 0 .526 0l3.728-2.157Z"
		></path>
	</svg>
))
